import {Clone} from "js-vextensions";
import {Column, Row, Select, Text, Button, TextArea, CheckBox} from "react-vcomponents";
import {ScrollView} from "react-vscrollview";
import {BaseComponent} from "react-vextensions";
import {ShowMessageBox} from "react-vmessagebox";
import {InfoButton, TimeToString, VDateTime} from "web-vcore";
import {SessionEvent, SessionEventType_values} from "../../../../Engine/LiveSession/SessionEvent.js";
import {SessionChangerFunc, SessionUI_SharedProps} from "../SessionUI.js";
import React, {useState} from "react";
import moment from "moment";
import {DialogStyle} from "../../../../Utils/UI/GlobalStyles.js";

export const SessionUI_EventsUI = ((props: {} & SessionUI_SharedProps)=>{
	const {session, ChangeSession} = props;
	return (
		<Column style={{flex: 1}}>
			<Row>
				<Text>Events:</Text>
				<Button ml={5} mdIcon="plus" title="Add new event" onClick={()=>{
					ShowMessageBox({
						title: "Add event", cancelButton: true,
						message: "Add a new event at the current time?",
						onOK: ()=>{
							const newEvent = new SessionEvent({date: Date.now(), type: SessionEventType_values[0]});
							ChangeSession(newSession=>newSession.events.push(newEvent));
						},
					});
				}}/>
			</Row>
			<ScrollView style={{flex: 1}}>
				{session.events.map((entry, index)=>{
					return <SessionEventUI key={index} {...{ChangeSession}} event={entry} index={index}/>
				})}
			</ScrollView>
		</Column>
	);
});

const SessionEventUI = (props: {event: SessionEvent, index: number, ChangeSession: (changerFunc: SessionChangerFunc)=>void})=>{
	const {event, index, ChangeSession} = props;

	const [editingTime, setEditingTime] = useState(false);

	const ChangeEvent = (changerFunc: (oldEvent: SessionEvent)=>any)=>{
		const newEvent = Clone(event);
		changerFunc(newEvent);
		ChangeSession(newSession=>newSession.events[index] = newEvent);
	}

	const SessionEventType_values_plusCurrentValIfNotInList = [
		...(SessionEventType_values.includes(event.type) ? [] : [{name: `[invalid] ${event.type}`, value: event.type}]),
		...SessionEventType_values
	];
	const event_extraProps = event.ExcludeKeys("date", "type");
	const hasExtraProps = Object.getOwnPropertyNames(event_extraProps).length > 0;

	return (
		<Row key={index} center style={{padding: "5px 0"}}>
			<Text>Time:</Text>
			{!editingTime && <Text ml={5} style={{width: 60}}>{TimeToString(event.date, {date: 0})}</Text>}
			{editingTime && <VDateTime inputProps={{style: {marginLeft: 5}}} dateFormat="YYYY-MM-DD" timeFormat="HH:mm:ss" value={event.date ? moment(event.date) : null} onChange={val=>{
				const val_final = val?.valueOf() ?? null;
				if (val_final == null) return;
				ChangeEvent(a=>a.date = val_final);
			}}/>}
			<Button ml={5} mdIcon={editingTime ? "close-circle" : "clock-edit"} title={editingTime ? "Close time editor" : "Edit time"} onClick={()=>{
				setEditingTime(!editingTime);
			}}/>
			<Text ml={5}>Type:</Text>
			<Select ml={5} options={SessionEventType_values_plusCurrentValIfNotInList} value={event.type} onChange={val=>ChangeEvent(a=>a.type = val)}/>
			<CheckBox ml={5} text="Invalidated" value={event.invalidated ?? false} onChange={val=>ChangeEvent(a=>a.invalidated = val || undefined)}/>
			<InfoButton ml={5} text="If invalidated, this event will be ignored in some graphical contexts. (mainly the session detail-chart atm)"/>
			<Button ml={5} mdIcon="content-copy" title="Clone event. (placed at next index, with same time and type)" onClick={()=>{
				ChangeSession(newSession=>newSession.events.Insert(index + 1, Clone(event)));
			}}/>
			<Button ml={5} text="JSON" onClick={()=>{
				let newJSON = JSON.stringify(event, undefined, "\t");
				const controller = ShowMessageBox({
					title: "JSON of session-event (editable)", cancelButton: true,
					okOnEnterKey: false, // disable Enter hotkey, so user can add lines to text-area
					message: ()=><Column style={DialogStyle({width: 600})}>
						<TextArea editable={true} style={{width: "100%", height: 500}} value={newJSON} onChange={val=>{
							newJSON = val;
							controller.UpdateUI();
						}}/>
					</Column>,
					onOK: ()=>{
						const newEventData = JSON.parse(newJSON);
						ChangeSession(session=>{
							const targetEvent = session.events[index];
							// clear all props on target session-event, then set new ones
							for (const key of Object.keys(targetEvent)) {
								delete targetEvent[key];
							}
							Object.assign(targetEvent, newEventData);
						});
					}
				});
			}}/>
			<Button ml={5} mdIcon="delete" title="Delete event." onClick={()=>{
				ShowMessageBox({
					title: "Delete event?", cancelButton: true,
					message: `Permanently delete this event?`,
					onOK: ()=>ChangeSession(newSession=>newSession.events.RemoveAt(index)),
				});
			}}/>
			{hasExtraProps && <Text sel ml={5}>{JSON.stringify(event_extraProps)}</Text>}
		</Row>
	);
};